import { stringToInteger } from '../utils/numberUtils'
import { Input } from '@/components/ui/input'
import { forwardRef, useState } from 'react'

export interface InputIntegerProps {
  id: string
  name: string
  label?: string
  value?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  onFocus?: () => void
  disabled?: boolean
  required?: boolean
  allowNegative?: boolean
  dropLeadingZeros?: boolean
  maxLength?: number
}

export const InputInteger = forwardRef<HTMLInputElement, InputIntegerProps>(
  (props, ref) => {
    const {
      id,
      name,
      label,
      value,
      onBlur,
      onChange,
      onFocus,
      disabled,
      required,
      allowNegative = true,
      dropLeadingZeros = true,
      maxLength
    } = props

    const [privateValue, setPrivateValue] = useState(value ?? '')

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      let newValue = stringToInteger(event.target.value, {
        dropLeadingZeros,
        preserveSign: allowNegative
      })

      // optionally cap length of user input
      if (maxLength !== undefined) {
        newValue = newValue.slice(0, maxLength)
      }

      setPrivateValue(newValue)

      if (privateValue !== newValue) {
        onChange?.(newValue)
      }
    }

    return (
      <div>
        {label && <label htmlFor={id}>{label}</label>}
        <Input
          id={id}
          type='text'
          name={name}
          value={privateValue}
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          inputMode='numeric'
          aria-required={required}
          ref={ref}
        />
      </div>
    )
  }
)
InputInteger.displayName = 'InputInteger'
